'use strict';

module.exports = function () {
	if (/Android | webOS | iPhone | iPad | iPod | BlackBerry | IEMobile | Opera Mini/i.test(navigator.userAgent)) {
		document.body.classList.add('mobile');
	}
};